// DEPENDENCIES
import React from 'react';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';
import Card from 'parts/card/Card';

const WholeSaleInfoForm = () => {
  return (
    <Form.Body>
      <Form.PlainText label="Sold Source" name="source_name" />
    </Form.Body>
  );
};
// EXPORT
export default function WholeSaleInfo(props) {
  return <Card title="Wholesale Info" body={<WholeSaleInfoForm {...props} />} />;
}
